define(
    'viewmodels/message',[
        "viewmodels/ViewModel",
        "services/config",
        "plugins/router",
        "i19n!i19n/strings"
    ],
    function (ViewModel, config, router, i19n) {

        var vm = new ViewModel(
        {
            i19n: i19n,
            title: ko.observable(),
            message: ko.observable(),
            message2: ko.observable(),
        });

        vm.activate = function () {

        };
        vm.attached = function () {
        };
        vm.explore = function () {
            router.navigate("explorer");
        };
        vm.clickHelp = function () {
            window.open('http://help.fileplan.com');
        };


        return vm;
    }
);
